import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import React from "react";
import { Filter, NumberInput, SelectInput, TextInput } from "react-admin";

import { useEnumSelectChoices } from "../../../components/_helpers/useEnumSelectChoices";
import { ToggleStateFilter } from "../../../components/filters/ToggleStateFilter";
import { OSFCUserSelectInput } from "../../../components/inputs/OSFCUserSelect";
import { PortInput } from "../../../components/inputs/PortInput";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import { LinkOrderType } from "../../../entities/LinkOrderType";
import { OrderGroupCargoType } from "../../../entities/OrderGroupCargoType";
import { OrderGroupState } from "../../../entities/OrderGroupState";
import { useOutDocStatuses } from "../../../utils/hooks/useOutDocStatuses";

const orderGroupStateToggles = [
	{ value: OrderGroupState.notActive, name: "osfc.filters.state.not_active" },
	{ value: OrderGroupState.active, name: "osfc.filters.state.active" },
	{ value: OrderGroupState.upcoming, name: "osfc.filters.state.upcoming" },
	{ value: OrderGroupState.all, name: "osfc.filters.state.all" },
];

export const OrderGroupsFilter = (props) => {
	const cargoTypeChoices = useEnumSelectChoices(OrderGroupCargoType, "order-group-cargo-type");
	const { choices: siStatusChoices } = useOutDocStatuses();
	const linkOrderTypeChoices = useEnumSelectChoices(LinkOrderType, "link-order-type");
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();

	const portsFilter = globalFilters?.terminal_id?.length
		? { terminal_id: [globalFilters.terminal_id[0]] }
		: {};

	return (
		<Filter {...props}>
			<ToggleStateFilter
				source="group_state"
				toggleStates={orderGroupStateToggles}
				selectedValueWhenEmpty={OrderGroupState.all}
				defaultValue={null}
				alwaysOn
			/>
			<NumberInput source="id" />
			<SelectInput source="cargo_type" choices={cargoTypeChoices} />
			<YesNoInput source="is_confirmed" label="resources.order-groups.filters.is_confirmed" />
			<OSFCUserSelectInput source="task_taken_by" />
			<NumberInput source="rank" />
			<SelectInput source="si_status" choices={siStatusChoices} />
			<SelectInput source="link_order_type" choices={linkOrderTypeChoices} />
			<TextInput source="truck" />
			<NumberInput source="truck_id" />
			<TextInput source="trailer" />
			<NumberInput source="trailer_id" />
			<TextInput source="trip_number" />
			<PortInput
				source="port"
				label="resources.order-groups.fields.port"
				filter={portsFilter}
				disableValue={null}
			/>
		</Filter>
	);
};
